import { ParentTypes as Parent_Type_Enum } from '@risksmart-app/domain/src/types/consts/parent-type';
import type { FieldValues } from 'react-hook-form';

import { useGetOversightAssessmentsRegister } from '@/hooks/queries';
import { getFriendlyId } from '@/utils/friendlyId';

import ControlledSelect from '../controlled-select';
import type { ControlledBaseProps } from '../types';

interface Props<T extends FieldValues> extends ControlledBaseProps<T> {
  addEmptyOption?: boolean;
  disabled?: boolean;
  testId: string;
}

export const ControlledOversightAssessmentSelector = <T extends FieldValues>({
  ...props
}: Props<T>) => {
  const { data, loading } = useGetOversightAssessmentsRegister({
    queryArgs: {},
  });

  const options =
    data?.oversight_assessment.map((assessment) => ({
      value: assessment.Id,
      label:
        assessment?.Title ??
        getFriendlyId(
          Parent_Type_Enum.OversightAssessment,
          assessment.SequentialId
        ),
    })) ?? [];

  return (
    <ControlledSelect
      statusType={loading ? 'loading' : 'finished'}
      options={options}
      {...props}
    />
  );
};

export default ControlledOversightAssessmentSelector;
